import { render, staticRenderFns } from "./consanguinity.vue?vue&type=template&id=579032fc"
import script from "./consanguinity.vue?vue&type=script&lang=js"
export * from "./consanguinity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579032fc')) {
      api.createRecord('579032fc', component.options)
    } else {
      api.reload('579032fc', component.options)
    }
    module.hot.accept("./consanguinity.vue?vue&type=template&id=579032fc", function () {
      api.rerender('579032fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/relationship/consanguinity.vue"
export default component.exports